import script from "./WhatsappCodeMonitorPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./WhatsappCodeMonitorPage.vue?vue&type=script&lang=ts&setup=true"

import "./WhatsappCodeMonitorPage.vue?vue&type=style&index=0&id=42bcaeea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42bcaeea"]])

export default __exports__